import { string, number, object } from 'yup';

const requiredField = 'This field is required';

export const MemoRandumSchema = object().shape({
  subject: string().max(150, 'The maximum is 150 characters').required(requiredField),
  patientName: string().required(requiredField),
  patientNric: string().required(requiredField),
  content: string().required(requiredField),
  // clinicId: number().nullable().required(requiredField),
  paymentType: number().required(requiredField),
});
